import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Switch, Redirect } from "react-router-dom";

import AdministrationAdvancedChannels from "pages/administration/advanced/Channels";
import AdministrationAdvancedChannelsConfirm from "pages/administration/advanced/confirmations/ChannelsConfirm";
import AdministrationAdvancedChannelsTicket from "pages/administration/advanced/tickets/ChannelsTicket";
import AdministrationAdvancedGroup from "pages/administration/advanced/Group";
import AdministrationAdvancedGroupFormContainer from "pages/administration/advanced/GroupFormContainer";
import AdministrationAdvancedGroupsOfUser from "pages/administration/advanced/GroupsOfUser";
import AdministrationAdvancedGroupsOfUserConfirm from "pages/administration/advanced/confirmations/GroupsOfUserConfirm";
import AdministrationAdvancedGroupsOfUserTicket from "pages/administration/advanced/tickets/GroupsOfUserTicket";
import AdministrationAdvancedGroupFormDataTicket from "pages/administration/advanced/tickets/GroupFormDataTicket";
import AdministrationAdvancedSignatureConfirm from "pages/administration/advanced/confirmations/SignatureConfirm";
import AdministrationAdvancedSignatureTicket from "pages/administration/advanced/tickets/SignatureTicket";
import AdministrationAdvancedSignaturesSchemeCreate from "pages/administration/advanced/SignaturesSchemeCreate";
import AdministrationAdvancedSignaturesSchemeCreateConfirmation from "pages/administration/advanced/confirmations/SignaturesSchemeCreate";
import AdministrationAdvancedSignaturesSchemeDeleteConfirmation from "pages/administration/advanced/confirmations/SignaturesSchemeDelete";
import AdministrationAdvancedSignaturesSchemeDetail from "pages/administration/advanced/SignatureSchemeDetails";
import AdministrationAdvancedSignaturesSchemeModify from "pages/administration/advanced/SignaturesSchemeModify";
import AdministrationAdvancedSignaturesSchemeModifyConfirmation from "pages/administration/advanced/confirmations/SignaturesSchemeModify";
import AdministrationAdvancedSignaturesSchemes from "pages/administration/advanced/SignaturesSchemes";
import AdministrationAdvancedSignaturesSchemeTicket from "pages/administration/advanced/tickets/SignaturesScheme";
import AdministrationGroups from "pages/administration/advanced/Groups";
import AdministrationMediumChannels from "pages/administration/medium/Channels";
import AdministrationMediumChannelsConfirm from "pages/administration/medium/confirmations/ChannelsConfirm";
import AdministrationMediumChannelsTicket from "pages/administration/medium/tickets/ChannelsTicket";
import AdministrationMediumDetails from "pages/administration/medium/Details";
import AdministrationAdvancedDetails from "pages/administration/advanced/Details";
import AdministrationMediumPermissions from "pages/administration/medium/Permissions";
import AdministrationMediumPermissionsConfirm from "pages/administration/medium/confirmations/PermissionsConfirm";
import AdministrationMediumPermissionsTicket from "pages/administration/medium/tickets/PermissionsTicket";
import AdministrationMediumSignatureConfirm from "pages/administration/medium/confirmations/SignatureConfirm";
import AdministrationMediumSignaturesSchemeCreate from "pages/administration/medium/SignaturesSchemeCreate";
import AdministrationMediumSignaturesSchemeCreateConfirmation from "pages/administration/medium/confirmations/SignaturesSchemeCreate";
import AdministrationMediumSignaturesSchemeDeleteConfirmation from "pages/administration/medium/confirmations/SignaturesSchemeDelete";
import AdministrationMediumSignaturesSchemeDetail from "pages/administration/medium/SignatureSchemeDetails";
import AdministrationMediumSignaturesSchemeModify from "pages/administration/medium/SignaturesSchemeModify";
import AdministrationMediumSignaturesSchemeModifyConfirmation from "pages/administration/medium/confirmations/SignaturesSchemeModify";
import AdministrationMediumSignaturesSchemes from "pages/administration/medium/SignaturesSchemes";
import AdministrationMediumSignaturesSchemeTicket from "pages/administration/medium/tickets/SignaturesScheme";
import AdministrationSimplePermissions from "pages/administration/simple/Permissions";
import AdministrationSimplePermissionsConfirm from "pages/administration/simple/PermissionsConfirm";
import AdministrationSimplePermissionsTicket from "pages/administration/simple/PermissionsTicket";
import AdministrationDispatcherConfirm from "pages/administration/_components/DispatcherConfirm";
import AdministrationUsers from "pages/administration/Users";
import GroupActionConfirmation from "pages/administration/advanced/GroupActionConfirmation";
import CreateGroupSignTransaction from "pages/administration/advanced/CreateGroupSignTransaction";
import GroupActionTicket from "pages/administration/advanced/GroupActionTicket";
import UserActionTicket from "pages/administration/UserActionTicket";
import UserActionConfirmation from "pages/administration/UserActionConfirmation";
import UserInviteTicket from "pages/administration/UserInviteTicket";
import Notification from "pages/_components/Notification";
import { resizableRoute } from "pages/_components/Resizable";
import Restrictions from "pages/administration/restrictions/Restrictions";
import RestrictionsDeleteConfirmation from "pages/administration/restrictions/confirmations/RestrictionsDeleteConfirmation";
import RestrictionsManageConfirmation from "pages/administration/restrictions/confirmations/RestrictionsManageConfirmation";
import RestrictionsManageTicket from "pages/administration/restrictions/tickets/RestrictionsManageTicket";
import RestrictionsUserDeleteTicket from "pages/administration/restrictions/tickets/RestrictionsUserDeleteTicket";
import AdministrationMediumUpdateUserTicket from "pages/administration/medium/tickets/UpdateUserTicket";
import AdministrationAdvancedUpdateUserTicket from "pages/administration/advanced/tickets/UpdateUserTicket";
import { func, bool } from "prop-types";
import PrivateRoute from "pages/_components/route/PrivateRoute";
import { actions as layoutActions } from "reducers/layout";
import { dispatchV3ShellLayout, isUxDashboardImprovementsEnabled } from "util/v3ShellLayoutSync";
import { getPostLoginHomePath } from "util/v3UxConfig";

class Administration extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        isDesktop: bool,
        isSmallDesktop: bool,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        isDesktop: false,
        isSmallDesktop: false,
        embeddedInV3Shell: false,
    };

    componentDidMount() {
        const { dispatch, embeddedInV3Shell } = this.props;

        if (embeddedInV3Shell && isUxDashboardImprovementsEnabled()) {
            dispatchV3ShellLayout(dispatch, {
                titleKey: "menu.administration",
                goBackPath: getPostLoginHomePath(true),
                rightContentMobile: null,
                scopes: ["administration"],
            });
        }
    }

    componentWillUnmount() {
        const { dispatch, embeddedInV3Shell } = this.props;

        if (embeddedInV3Shell && isUxDashboardImprovementsEnabled()) {
            dispatch(layoutActions.setScopes([]));
            dispatch(layoutActions.setTitleKey(""));
            dispatch(layoutActions.setGoBackPath(null));
            dispatch(layoutActions.setRightContentMobile(null));
        }
    }

    renderTicketRoutes = () => {
        const { isDesktop, isSmallDesktop, embeddedInV3Shell } = this.props;
        const ticketRoutes = [
            <PrivateRoute
                excludeEnvType={["retail"]}
                exact
                path="/administration/simple/permissions/:idTransaction/ticket"
                render={({ match }) => (
                    <AdministrationSimplePermissionsTicket
                        match={match}
                        isDesktop={isDesktop}
                        isSmallDesktop={isSmallDesktop}
                        embeddedInV3Shell={embeddedInV3Shell}
                    />
                )}
            />,
            <PrivateRoute
                excludeEnvType={["retail"]}
                exact
                path="/administration/medium/permissions/:idTransaction/ticket"
                render={({ match }) => (
                    <AdministrationMediumPermissionsTicket
                        match={match}
                        isDesktop={isDesktop}
                        isSmallDesktop={isSmallDesktop}
                        embeddedInV3Shell={embeddedInV3Shell}
                    />
                )}
            />,
            <PrivateRoute
                excludeEnvType={["retail"]}
                exact
                path="/administration/medium/channels/:idTransaction/ticket"
                render={({ match }) => (
                    <AdministrationMediumChannelsTicket
                        match={match}
                        isDesktop={isDesktop}
                        isSmallDesktop={isSmallDesktop}
                        embeddedInV3Shell={embeddedInV3Shell}
                    />
                )}
            />,
            <PrivateRoute
                excludeEnvType={["retail"]}
                exact
                path="/administration/medium/signaturesSchemes/:idTransaction/ticket"
                render={({ match }) => (
                    <AdministrationMediumSignaturesSchemeTicket
                        match={match}
                        isDesktop={isDesktop}
                        isSmallDesktop={isSmallDesktop}
                        embeddedInV3Shell={embeddedInV3Shell}
                    />
                )}
            />,
            <PrivateRoute
                excludeEnvType={["retail"]}
                exact
                path="/administration/advanced/signaturesSchemes/:idTransaction/ticket"
                render={({ match }) => (
                    <AdministrationAdvancedSignaturesSchemeTicket
                        match={match}
                        isDesktop={isDesktop}
                        isSmallDesktop={isSmallDesktop}
                        embeddedInV3Shell={embeddedInV3Shell}
                    />
                )}
            />,
            <PrivateRoute
                excludeEnvType={["retail"]}
                exact
                path="/administration/users/actions/:idTransaction/ticket"
                render={({ match }) => (
                    <UserActionTicket
                        match={match}
                        isDesktop={isDesktop}
                        isSmallDesktop={isSmallDesktop}
                        embeddedInV3Shell={embeddedInV3Shell}
                    />
                )}
            />,
            <PrivateRoute
                excludeEnvType={["retail"]}
                exact
                path="/administration/groups/actions/:idTransaction/ticket"
                render={({ match }) => (
                    <GroupActionTicket
                        match={match}
                        isDesktop={isDesktop}
                        isSmallDesktop={isSmallDesktop}
                        embeddedInV3Shell={embeddedInV3Shell}
                    />
                )}
            />,
            <PrivateRoute
                excludeEnvType={["retail"]}
                exact
                path="/administration/medium/userInvite/:idTransaction/ticket"
                render={({ match }) => (
                    <UserInviteTicket
                        match={match}
                        isDesktop={isDesktop}
                        isSmallDesktop={isSmallDesktop}
                        embeddedInV3Shell={embeddedInV3Shell}
                    />
                )}
            />,
            <PrivateRoute
                excludeEnvType={["retail"]}
                exact
                path="/administration/advanced/signature/:idTransaction/ticket"
                render={({ match }) => (
                    <AdministrationAdvancedSignatureTicket
                        match={match}
                        isDesktop={isDesktop}
                        isSmallDesktop={isSmallDesktop}
                        embeddedInV3Shell={embeddedInV3Shell}
                    />
                )}
            />,
            <PrivateRoute
                excludeEnvType={["retail"]}
                exact
                path="/administration/advanced/channels/:idTransaction/ticket"
                render={({ match }) => (
                    <AdministrationAdvancedChannelsTicket
                        match={match}
                        isDesktop={isDesktop}
                        isSmallDesktop={isSmallDesktop}
                        embeddedInV3Shell={embeddedInV3Shell}
                    />
                )}
            />,
            <PrivateRoute
                excludeEnvType={["retail"]}
                exact
                path="/administration/advanced/groupsOfUser/:idTransaction/ticket"
                render={({ match }) => (
                    <AdministrationAdvancedGroupsOfUserTicket
                        match={match}
                        isDesktop={isDesktop}
                        isSmallDesktop={isSmallDesktop}
                        embeddedInV3Shell={embeddedInV3Shell}
                    />
                )}
            />,
            <PrivateRoute
                excludeEnvType={["retail"]}
                exact
                path="/administration/advanced/groupFormData/:idTransaction/ticket"
                render={({ match }) => (
                    <AdministrationAdvancedGroupFormDataTicket
                        match={match}
                        isDesktop={isDesktop}
                        isSmallDesktop={isSmallDesktop}
                        embeddedInV3Shell={embeddedInV3Shell}
                    />
                )}
            />,
        ];
        return ticketRoutes;
    };

    render() {
        const { isDesktop, isSmallDesktop, embeddedInV3Shell } = this.props;
        const ticketRoutes = this.renderTicketRoutes();
        const showLegacyNotification = !embeddedInV3Shell || !isUxDashboardImprovementsEnabled();

        if (!isDesktop) {
            return (
                <Fragment>
                    {showLegacyNotification && <Notification scopeToShow="administration" />}
                    <Switch>
                        {ticketRoutes.map((element) => element)}
                        <Redirect to="/desktop" />
                    </Switch>
                </Fragment>
            );
        }

        return (
            <Fragment>
                {showLegacyNotification && <Notification scopeToShow="administration" />}

                <Switch>
                    {ticketRoutes.map((element) => element)}

                    <PrivateRoute excludeEnvType={["retail"]} path="/administration/simple/permissions/:id">
                        {(props) => (
                            <AdministrationSimplePermissions
                                {...props}
                                embeddedInV3Shell={embeddedInV3Shell}
                                confirmRoute={
                                    <PrivateRoute
                                        excludeEnvType={["retail"]}
                                        exact
                                        path="/administration/simple/permissions/:id/confirm"
                                        render={(rp) => (
                                            <AdministrationSimplePermissionsConfirm
                                                {...rp}
                                                embeddedInV3Shell={embeddedInV3Shell}
                                            />
                                        )}
                                    />
                                }
                            />
                        )}
                    </PrivateRoute>

                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/users"
                        render={(rp) => <AdministrationUsers {...rp} embeddedInV3Shell={embeddedInV3Shell} />}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/confirmUserAction"
                        render={(rp) => <UserActionConfirmation {...rp} embeddedInV3Shell={embeddedInV3Shell} />}
                    />

                    {/* end of simple scheme routes */}
                    {/* medium scheme routes */}
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/medium/details/:id"
                        render={(rp) => <AdministrationMediumDetails {...rp} embeddedInV3Shell={embeddedInV3Shell} />}
                    />

                    <PrivateRoute excludeEnvType={["retail"]} path="/administration/medium/permissions/:id">
                        {(props) => (
                            <AdministrationMediumPermissions
                                {...props}
                                embeddedInV3Shell={embeddedInV3Shell}
                                confirmRoute={
                                    <PrivateRoute
                                        excludeEnvType={["retail"]}
                                        exact
                                        path="/administration/medium/permissions/:id/confirm"
                                        render={(rp) => (
                                            <AdministrationMediumPermissionsConfirm
                                                {...rp}
                                                embeddedInV3Shell={embeddedInV3Shell}
                                            />
                                        )}
                                    />
                                }
                            />
                        )}
                    </PrivateRoute>

                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/medium/channels/:id"
                        render={(rp) => <AdministrationMediumChannels {...rp} embeddedInV3Shell={embeddedInV3Shell} />}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/medium/channels/:id/confirm"
                        render={(rp) => (
                            <AdministrationMediumChannelsConfirm {...rp} embeddedInV3Shell={embeddedInV3Shell} />
                        )}
                    />

                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/medium/signaturesSchemes"
                        render={(rp) => (
                            <AdministrationMediumSignaturesSchemes {...rp} embeddedInV3Shell={embeddedInV3Shell} />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/medium/signaturesSchemes/create"
                        render={(rp) => (
                            <AdministrationMediumSignaturesSchemeCreate {...rp} embeddedInV3Shell={embeddedInV3Shell} />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/medium/signaturesSchemes/create/confirm"
                        render={(rp) => (
                            <AdministrationMediumSignaturesSchemeCreateConfirmation
                                {...rp}
                                embeddedInV3Shell={embeddedInV3Shell}
                            />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/medium/signaturesSchemes/remove/:idSignature"
                        render={(rp) => (
                            <AdministrationMediumSignaturesSchemeDeleteConfirmation
                                {...rp}
                                embeddedInV3Shell={embeddedInV3Shell}
                            />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/medium/signaturesSchemes/:idSignature"
                        render={(rp) => (
                            <AdministrationMediumSignaturesSchemeModify {...rp} embeddedInV3Shell={embeddedInV3Shell} />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/medium/signaturesSchemes/:idSignature/confirm"
                        render={(rp) => (
                            <AdministrationMediumSignaturesSchemeModifyConfirmation
                                {...rp}
                                embeddedInV3Shell={embeddedInV3Shell}
                            />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/medium/signature/:id/confirm"
                        render={(rp) => (
                            <AdministrationMediumSignatureConfirm {...rp} embeddedInV3Shell={embeddedInV3Shell} />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/medium/signaturesSchemes/detail/:idSignature"
                        render={(rp) => (
                            <AdministrationMediumSignaturesSchemeDetail {...rp} embeddedInV3Shell={embeddedInV3Shell} />
                        )}
                    />
                    {/* end of medium scheme routes */}

                    {/* advanced scheme routes */}

                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/advanced/group/:id/details"
                        render={(rp) => <AdministrationAdvancedGroup {...rp} embeddedInV3Shell={embeddedInV3Shell} />}
                    />

                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/advanced/signaturesSchemes"
                        render={(rp) => (
                            <AdministrationAdvancedSignaturesSchemes {...rp} embeddedInV3Shell={embeddedInV3Shell} />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/advanced/signaturesSchemes/create"
                        render={(rp) => (
                            <AdministrationAdvancedSignaturesSchemeCreate
                                {...rp}
                                embeddedInV3Shell={embeddedInV3Shell}
                            />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/advanced/signaturesSchemes/create/confirm"
                        render={(rp) => (
                            <AdministrationAdvancedSignaturesSchemeCreateConfirmation
                                {...rp}
                                embeddedInV3Shell={embeddedInV3Shell}
                            />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/advanced/signaturesSchemes/remove/:idSignature"
                        render={(rp) => (
                            <AdministrationAdvancedSignaturesSchemeDeleteConfirmation
                                {...rp}
                                embeddedInV3Shell={embeddedInV3Shell}
                            />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/advanced/signaturesSchemes/:idSignature"
                        render={(rp) => (
                            <AdministrationAdvancedSignaturesSchemeModify
                                {...rp}
                                embeddedInV3Shell={embeddedInV3Shell}
                            />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/advanced/signaturesSchemes/:idSignature/confirm"
                        render={(rp) => (
                            <AdministrationAdvancedSignaturesSchemeModifyConfirmation
                                {...rp}
                                embeddedInV3Shell={embeddedInV3Shell}
                            />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/advanced/signaturesSchemes/detail/:idSignature"
                        render={(rp) => (
                            <AdministrationAdvancedSignaturesSchemeDetail
                                {...rp}
                                embeddedInV3Shell={embeddedInV3Shell}
                            />
                        )}
                    />

                    {/* end of advanced scheme routes */}

                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/users/dispatcher/:id/confirm"
                        render={(rp) => (
                            <AdministrationDispatcherConfirm {...rp} embeddedInV3Shell={embeddedInV3Shell} />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/users/actions/:idTransaction/ticket"
                        render={({ match }) => (
                            <UserActionTicket
                                match={match}
                                isDesktop={isDesktop}
                                isSmallDesktop={isSmallDesktop}
                                embeddedInV3Shell={embeddedInV3Shell}
                            />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/groups/actions/:idTransaction/ticket"
                        render={({ match }) => (
                            <GroupActionTicket
                                match={match}
                                isDesktop={isDesktop}
                                isSmallDesktop={isSmallDesktop}
                                embeddedInV3Shell={embeddedInV3Shell}
                            />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/medium/userInvite/:idTransaction/ticket"
                        render={({ match }) => (
                            <UserInviteTicket
                                match={match}
                                isDesktop={isDesktop}
                                isSmallDesktop={isSmallDesktop}
                                embeddedInV3Shell={embeddedInV3Shell}
                            />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/groups"
                        render={(rp) => <AdministrationGroups {...rp} embeddedInV3Shell={embeddedInV3Shell} />}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/confirmGroupAction"
                        render={(rp) => <GroupActionConfirmation {...rp} embeddedInV3Shell={embeddedInV3Shell} />}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        path="/administration/advanced/group/create"
                        render={(rp) => (
                            <AdministrationAdvancedGroupFormContainer {...rp} embeddedInV3Shell={embeddedInV3Shell} />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/advanced/group/sign/create"
                        render={(rp) => <CreateGroupSignTransaction {...rp} embeddedInV3Shell={embeddedInV3Shell} />}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        path="/administration/advanced/group/:id"
                        render={(rp) => (
                            <AdministrationAdvancedGroupFormContainer {...rp} embeddedInV3Shell={embeddedInV3Shell} />
                        )}
                    />
                    {/* end of advanced scheme routes */}

                    {/* advanced scheme routes */}
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/advanced/details/:id"
                        render={(rp) => <AdministrationAdvancedDetails {...rp} embeddedInV3Shell={embeddedInV3Shell} />}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/advanced/signature/:id/confirm"
                        render={(rp) => (
                            <AdministrationAdvancedSignatureConfirm {...rp} embeddedInV3Shell={embeddedInV3Shell} />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/advanced/signature/:idTransaction/ticket"
                        render={({ match }) => (
                            <AdministrationAdvancedSignatureTicket
                                match={match}
                                isDesktop={isDesktop}
                                isSmallDesktop={isSmallDesktop}
                                embeddedInV3Shell={embeddedInV3Shell}
                            />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/advanced/channels/:id"
                        render={(rp) => (
                            <AdministrationAdvancedChannels {...rp} embeddedInV3Shell={embeddedInV3Shell} />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/advanced/channels/:id/confirm"
                        render={(rp) => (
                            <AdministrationAdvancedChannelsConfirm {...rp} embeddedInV3Shell={embeddedInV3Shell} />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/advanced/usersUpdate/:idTransaction/ticket"
                        render={({ match }) => (
                            <AdministrationAdvancedUpdateUserTicket
                                match={match}
                                isDesktop={isDesktop}
                                isSmallDesktop={isSmallDesktop}
                                embeddedInV3Shell={embeddedInV3Shell}
                            />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/medium/usersUpdate/:idTransaction/ticket"
                        render={({ match }) => (
                            <AdministrationMediumUpdateUserTicket
                                match={match}
                                isDesktop={isDesktop}
                                isSmallDesktop={isSmallDesktop}
                                embeddedInV3Shell={embeddedInV3Shell}
                            />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/advanced/channels/:idTransaction/ticket"
                        render={({ match }) => (
                            <AdministrationAdvancedChannelsTicket
                                match={match}
                                isDesktop={isDesktop}
                                isSmallDesktop={isSmallDesktop}
                                embeddedInV3Shell={embeddedInV3Shell}
                            />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/advanced/groupsOfUser/:id"
                        render={(rp) => (
                            <AdministrationAdvancedGroupsOfUser {...rp} embeddedInV3Shell={embeddedInV3Shell} />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/advanced/groupsOfUser/:id/confirm"
                        render={(rp) => (
                            <AdministrationAdvancedGroupsOfUserConfirm {...rp} embeddedInV3Shell={embeddedInV3Shell} />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/advanced/groupsOfUser/:idTransaction/ticket"
                        render={({ match }) => (
                            <AdministrationAdvancedGroupsOfUserTicket
                                match={match}
                                isDesktop={isDesktop}
                                isSmallDesktop={isSmallDesktop}
                                embeddedInV3Shell={embeddedInV3Shell}
                            />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/advanced/groupFormData/:idTransaction/ticket"
                        render={({ match }) => (
                            <AdministrationAdvancedGroupFormDataTicket
                                match={match}
                                isDesktop={isDesktop}
                                isSmallDesktop={isSmallDesktop}
                                embeddedInV3Shell={embeddedInV3Shell}
                            />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/restrictions"
                        render={(rp) => <Restrictions {...rp} embeddedInV3Shell={embeddedInV3Shell} />}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/restrictions/:userId"
                        render={(rp) => <Restrictions {...rp} embeddedInV3Shell={embeddedInV3Shell} />}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/restrictions/delete/:userId"
                        render={(rp) => (
                            <RestrictionsDeleteConfirmation {...rp} embeddedInV3Shell={embeddedInV3Shell} />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/restrictions/manage/confirmation"
                        render={(rp) => (
                            <RestrictionsManageConfirmation {...rp} embeddedInV3Shell={embeddedInV3Shell} />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/restrictions/manage/:idTransaction/ticket/"
                        render={({ match }) => (
                            <RestrictionsManageTicket
                                match={match}
                                isDesktop={isDesktop}
                                isSmallDesktop={isSmallDesktop}
                                embeddedInV3Shell={embeddedInV3Shell}
                            />
                        )}
                    />
                    <PrivateRoute
                        excludeEnvType={["retail"]}
                        exact
                        path="/administration/restrictions/user/delete/:idTransaction/ticket/"
                        render={({ match }) => (
                            <RestrictionsUserDeleteTicket
                                match={match}
                                isDesktop={isDesktop}
                                isSmallDesktop={isSmallDesktop}
                                embeddedInV3Shell={embeddedInV3Shell}
                            />
                        )}
                    />
                    <Redirect to="/desktop" />
                </Switch>
            </Fragment>
        );
    }
}

export default compose(connect(), resizableRoute)(Administration);
